import { markdownItLinkPlugin } from "./utils";

export default class LinkPlugin {

  __name__ = 'replace-link';
  __text__ = 'reLink';
  __icon__ = 'el-icon-s-flag';
  __toolbar__ = '';

  __replace__ = (keyword) => {
    return `${keyword}`
  }

  __insert(content, selected) {
    return `[${content}](#${content})`
  }

  __selected(content, selected) {
    return `#${content}`
  }

  __init() {
    if (this.__editor__) {
      if (this.__editor__.name === 'v-md-editor') {
        this.__editor__.command(this.__name__, (editor) => {
          editor.insert((selected) => {
            const content = selected || this.__toolbar__ || this.__text__;
            return {
              text: this.__insert(content, selected),
              selected: this.__selected(content, selected),
            };
          });
        });
        this.__editor__.toolbar(this.__name__, {
          icon: this.__icon__,
          title: this.__toolbar__ || this.__name__,
          text: !!this.__icon__ ? '' : (this.__text__ || this.__name__),
          action: (editor) => {
            editor.execCommand(this.__name__);
          }
        });
      }
      this.__editor__.extendMarkdown((mdParser) => {
        if (mdParser) {
          mdParser.use(markdownItLinkPlugin, {
            pluginName: `v-md-plugin-${this.__name__}`,
            replaceLink: (content) => {
              return this.__replace__(content);
            },
          });
        }
      });
    }
  }

  isEnable() {
    return true;
  }

  setReplace(replaceFunc) {
    if (typeof replaceFunc === 'function') {
      this.__replace__ = replaceFunc;
      this.__init();
    }
  }

  install(editor) {
    this.__editor__ = editor;
    this.__init();
  }

}